import { defineComponent as _defineComponent } from 'vue'
import {computed} from "vue";
import FormGroupLabel from "@/components/forms/horizontal/FormGroupLabel.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HorizontalFormGroup',
  props: {
  label: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  hasErrors: {
    type: Boolean,
    default: false,
  },
  noLabelTag: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;




const groupClass = computed(() => {
  return { 'has-error': props.hasErrors, 'form-group-has-error': props.hasErrors };
})

const labelText = computed(() => {
  return props.label && (props.label.length > 0) ? props.label : '';
})

const labelClass = computed(() => {
  return { required: props.required };
})

return { __sfc: true,props, groupClass, labelText, labelClass, computed, FormGroupLabel }
}

})